export default __webpack_public_path__ + "static/media/teodor.7049996b.png";